import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { intialMessage, userMessage } from 'constants/ui.constants';

interface SystemState {
	loading: boolean;
	message: userMessage;
	settings: Record<string, any>;
}

const initialState: SystemState = {
	loading: false,
	message: intialMessage,
	settings: {},
};

export const systemSettingsSlice = createSlice({
	name: 'systemSettings',
	initialState,
	reducers: {
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
		setMessage: (state, action: PayloadAction<userMessage>) => {
			state.message = action.payload;
		},
		setSystemSettings: (state, action: PayloadAction<Record<string, any>>) => {
			state.settings = { ...state.settings, ...action.payload };
		},
		setDomainSettings: (state, action: PayloadAction<{ domain: string; settings: any }>) => {
			state.settings[action.payload.domain] = action.payload.settings;
		},
		clearSystemSettings: (state) => {
			state.settings = {};
		},
	},
});

export const { setLoading, setMessage, setSystemSettings, setDomainSettings, clearSystemSettings } =
	systemSettingsSlice.actions;

// Selectors
export const getSystemSettingsLoading = (state: any) => state.systemSettings.loading;
export const getSystemSettingsMessage = (state: any) => state.systemSettings.message;
export const getSystemSettingsData = (state: any) => state.systemSettings.settings;
export const getDomainSettings = (domain: string) => (state: any) => state.systemSettings.settings[domain] || {};

export default systemSettingsSlice.reducer;
